import angular from 'angular';

import commonModule from '../../../common';

export default angular
    .module('fp:customerportal:account:dispatchServices:components',
        [
            commonModule.name
        ]);